import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const repairOrderTirePositionsAdapter = getAdapter({ idFieldName: 'value' });

const repairOrderTirePositionsSlice = createSlice({
  name: 'repairOrderTirePositions',
  initialState: repairOrderTirePositionsAdapter.getInitialState(),
  reducers: {
    setRepairOrderTirePositions: (state, { payload: { repairOrderTirePositions } }) => {
      repairOrderTirePositionsAdapter.setAll(state, repairOrderTirePositions);
    },
  },
});

const selectors = repairOrderTirePositionsAdapter.getSelectors(
  ({ repairOrderTirePositions }) => repairOrderTirePositions,
);

export const getRepairOrderTirePositions = (state) => selectors.selectAll(state);

export const { setRepairOrderTirePositions } = repairOrderTirePositionsSlice.actions;

export default repairOrderTirePositionsSlice.reducer;
